import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';

// String TextField Component
const StringTextField = (props) => {
  const {
    hintValue,
    isReadOnly = false,
    name,
    formik,
    disableValidation = false,
    value,
    onChangeValue, // New custom value handler
    onFocusValue,
    ...otherProps
  } = props;

  const hasError =
    !disableValidation && formik && formik.touched[name] && formik.errors[name];

  const shouldShowError = hasError && !formik.values[name];

  const handleOnChange = (e) => {
    let newValue = e.target.value;

    // If you have a custom handler, use it to transform the value
    if (onChangeValue) {
      newValue = onChangeValue(newValue);
    }

    // Update Formik's field value if formik is provided
    if (formik) {
      formik.setFieldValue(name, newValue);
    }
  };

  const handleOnBlur = (e) => {
    if (onFocusValue) {
      let lastValue = e.target.value;
      onFocusValue(lastValue);
    }

    // Update Formik's touched state if formik is provided
    if (formik) {
      formik.setFieldTouched(name, true);
    }
  };

  return (
    <TextField
      {...otherProps}
      fullWidth
      variant="outlined"
      value={value || formik?.values[name] || ''}
      placeholder={hintValue ? String(hintValue) : ''}
      error={shouldShowError}
      helperText={shouldShowError ? formik.errors[name] : ''}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      InputProps={{
        readOnly: isReadOnly,
      }}
      InputLabelProps={{
        shrink: hintValue ? true : undefined, // Force shrink if displayHint is present
        // sx: {
        //   color:
        //     (value || formik?.values[name]) && !isReadOnly
        //       ? 'text.secondary'
        //       : undefined,
        // },
      }}
      // sx={{
      //   ...(hintValue &&
      //     !(value || formik?.values[name]) && {
      //       '& .MuiInputBase-input::placeholder': {
      //         color: 'text.primary', // Placeholder color when showing hintValue
      //       },
      //     }),
      // }}    
    />
  );
};

StringTextField.propTypes = {
  formik: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
    values: PropTypes.object,
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func.isRequired,
  }),
  hintValue: PropTypes.any,
  isReadOnly: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  disableValidation: PropTypes.bool,
  onChangeValue: PropTypes.func, // Custom handler to process the value
};

export default StringTextField;
